export const INDEXARTICLES = {
  'about-us': 'Information about Us',
  definitions: 'Definitions and Interpretation',
  'ordering-services': 'Ordering Services',
  'contact-terms': 'The Services and the Term of the Contract',
  fees: 'Fees and Payment',
  apps: 'The Applications',
  training: 'Training',
  security: 'Security',
  maintenance: 'Maintenance',
  licences: 'Licences',
  'terms-of-use': 'Applications and API Infrastructure Terms of Use',
  'customer-computer-systems': 'Customer Computer Systems',
  support: 'Support',
  'intellectual-property': 'Intellectual Property',
  'customer-data': 'Customer Data',
  confidentiality: 'Confidentiality',
  liability: 'Liability',
  indemnity: 'Indemnity',
  'force-majeure': 'Force Majeure',
  termination: 'Termination',
  notices: 'Notices',
  'parties-relationship': 'Relationship of Parties',
  assignment: 'Assignment',
  severance: 'Severance',
  'entire-agreement': 'Entire Agreement',
  variation: 'Variation',
  'no-waiver': 'No Waiver',
  'non-exclusivity': 'Non-Exclusivity',
  'law-jurisdiction': 'Law and Jurisdiction',
  'schedule-1': 'SCHEDULE 1',
};

export default INDEXARTICLES;
